define 'controller/SideWidgetController', ['jquery', 'lib/kryptonite'], ($) ->
  class SideWidgetController

    constructor: (@$el) ->
      @_onNewsletterSubscribeSubmit()
      @_onWidgetClose()

    _onNewsletterSubscribeSubmit: ->
      self = @
      $('body').on 'submit', '#newsletter-widget-form', (e) ->
        e.preventDefault()
        $('.widget__newsletter__error').hide()
        $form = $(@)
        email = $('#newsletterWidgetEmail').val()
        if !(self._isEmailValid(email))
          $('.widget__newsletter__error--format').show()
          return
        $.ajax
          url: "/newsletter/widget"
          type: 'post'
          data:
            email: email
          success: ->
            $('#loading-overlay').remove()
            $('.widget__newsletter').hide()
            $('.widget__newsletter__confirmation').show()
            self._hideForSession($form.closest('.widget'))
            self._pushNewsletterSubscription()
          error: (error) ->
            $('#loading-overlay').remove()
            if(error.status == 302)
              window.location.href ="/newsletter/abonnement-confirm?email="+btoa(unescape(encodeURIComponent(email)))
            else
              $('.widget__newsletter--technical').show()

    _onWidgetClose: ->
        self = @
        $('body').on 'click', '.widget .close', (e) ->
          widget = $(e.target).closest('.widget')
          self._hideForSession(widget)
          widget.remove();

    _hideForSession: (widget) ->
      widgetType = widget.data('widget-type')
      cookieName = 'hide-' + widgetType
      $.cookie(cookieName, 1, { path: "/"})

    _isEmailValid: (email) ->
      if email.length < 1
        return false
      regex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
      return regex.test(email)

    _pushNewsletterSubscription: ->
      $.ajax({
        url: "/api/datalayer/event/newslettersubscribe",
        type: 'GET',
        success: (data) ->
          if data == undefined
            return
          dataLayer.push(data)
      })

    destroy: ->
      @$el.off()